import { Box, Typography } from "@mui/material";
import { COLORS } from "../configs/config";

export const DarkTip = ({ active, payload, label }) => {
    if (!active || !payload?.length) return null;
    return (
        <Box sx={{
            bgcolor: COLORS.card,
            border: `1px solid ${COLORS.border}`,
            borderRadius: 2,
            p: 1,
            boxShadow: `0 2px 8px rgba(0,0,0,0.10)`,
        }}>
            <Typography variant="caption" sx={{ color: COLORS.g1, fontWeight: 600, display: "block", mb: 0.5 }}>
                {label}
            </Typography>
            {payload.map((p, i) => (
                <Typography key={i} variant="caption" sx={{ color: COLORS.tDim, display: "block" }}>
                    {p.name}:{" "}
                    <Box component="span" sx={{ color: COLORS.tSec, fontWeight: 600 }}>
                        {typeof p.value === "number" ? p.value.toFixed(2) : p.value}
                    </Box>
                </Typography>
            ))}
        </Box>
    );
};

export const BarTip = ({ active, payload, label }) => {
    if (!active || !payload?.length) return null;
    return (
        <Box sx={{
            bgcolor: COLORS.card,
            border: `1px solid ${COLORS.border}`,
            borderRadius: 2,
            p: 1,
            boxShadow: `0 2px 8px rgba(0,0,0,0.10)`,
        }}>
            <Typography variant="caption" sx={{ color: COLORS.g1, fontWeight: 600, display: "block", mb: 0.5 }}>
                {label}
            </Typography>
            {payload.map((p, i) => (
                <Typography key={i} variant="caption" sx={{ color: COLORS.tDim, display: "block" }}>
                    {p.name}:{" "}
                    <Box component="span" sx={{ color: COLORS.tSec, fontWeight: 600 }}>{p.value}</Box>
                </Typography>
            ))}
        </Box>
    );
};